<template>
    <tailwind-layout title="Dashboard">
        <template #header>

            <div class="flex justify-between">
                <h2>Dashboard</h2>
            </div>

        </template>
        <div class="overflow-hidden">
            <div class="rounded-md shadow overflow-x-auto">
                <div class="flex flex-col">
                    <div class="overflow-x-auto">
                        <div class="align-middle inline-block min-w-full">
                            Dashboard Coming soon..
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import Icon from '@/Shared/Icon.vue'
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import Pagination from '@/Shared/Pagination.vue'
import Button from "@/Jetstream/Button.vue";

export default {
    components: {
        Button,
        Icon,
        Pagination,
        TailwindLayout
    },
    props: {
    },
    data() {
        return {
        }
    },
    watch: {

    },
    methods: {

    },
}
</script>
